import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { catchError, finalize, of } from 'rxjs';
import { AddendumThreeDto, MultiplePropertyListingDto, PlanningReportDto, PropertyListingDto, RiskscapeDeedsCurrentOwnerInfoDto, RiskscapeExistingLandUseAndFeatureDto, RiskscapePropertyDetailsDto, RiskscapePropertyInfoDto, AddressDto, ContactDetailDto, OrganizationInvoiceDetailsDto, PropertyDetailDto, UploadFileDto, AddressDetailDto, RiskscapePositionLookupDto, DecodedImageResultDtoOperationResult, DecodedImageResultDto, RiskscapeAddressDto, TaskListDto } from '../../../../../../app/services/property-matrixV2/models';
import { FileManagementService, MapsService, PlanningReportService, PropertyListingService, SellMyPropertyService } from '../../../../../../app/services/property-matrixV2/services';
import { ActionOption, ColumnConfig, DataTableComponent } from '../../../../../../app/shared/components/data-table/data-table.component';
import { ProvideLatLonDialogComponent } from '../../../../../shared/components/provide-lat-lon-dialog/provide-lat-lon-dialog.component';
import { UserManagementService } from '../../../../../../app/services/property-matrixV2/services/user-management.service';
import { ListingStateService } from '../../../../../../app/shared/services/listing-state-service/listing-state.service';
import { NotificationService } from '../../../../../../app/shared/services/notification-service/notification.service';
import { MapStateCheckService } from '../../../../../../app/shared/services/map-state-check/map-state-check.service';
import { ReportingService } from '../../../../../../app/shared/services/reporting-service/reporting.service';
import { IndividualInvoiceDetailsVm } from '../../../../../../app/services/property-matrix/models';
import { PropertyMatrixSharedService } from '../../../../../../app/property-matrix-shared.service';
import { UserDto } from '../../../../../../app/services/property-matrixV2/models';

@Component({
  selector: 'app-confirm-property-seller-details',
  templateUrl: './confirm-property-seller-details.component.html',
  styleUrls: ['./confirm-property-seller-details.component.scss', '../../../../../../css/2-modules/_admin-portal.scss']
})
export class ConfirmPropertySellerDetailsComponent implements OnInit {

  @Input() selectedListing: PropertyListingDto = {};
  @Input() selectedListingGroup: MultiplePropertyListingDto = {};
  @Input() listingType: string = "";

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  sections = [
    { key: 1, value: '1. Property Boundary', checked: true },
    { key: 2, value: '2. Property Details', checked: true },
    { key: 3, value: '3. Address Details', checked: true },
    { key: 4, value: '4. Location For Pin', checked: true },
    { key: 5, value: '5. Current Owner Information', checked: true },
    { key: 6, value: '6. Confirm to continue', checked: true },
  ];

  sectionsIncorrect = [
    { key: 1, value: '1. Property Boundary', checked: true },
    { key: 2, value: '2. Boundary Information from Seller', checked: true },
    { key: 3, value: '3. Property Details', checked: true },
    { key: 4, value: '4. Property Information From Seller', checked: true },
    { key: 5, value: '5. Re-order Riskscape data', checked: true },
    { key: 6, value: '6. Property Details Corrections', checked: true },
    { key: 7, value: '7. Address Details', checked: true },
    { key: 8, value: '8. Location For Pin', checked: true },
    { key: 9, value: '9. Current Owner Information', checked: true },
    { key: 10, value: '10. Confirm to complete', checked: true },
  ];

  data = [
    { name: "", idNumber: "", maritalStatus: "", ownerType: "", ownerShare: "" },
  ];

  displayedColumns: string[] = ['name', 'idNumber', 'maritalStatus', 'ownerType', 'ownerShare'];

  columns: ColumnConfig[] = [
    { columnDef: 'name', header: 'Name', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'idNumber', header: 'ID Number', headerAlign: 'left', cellAlign: 'left', width: 20 },
    { columnDef: 'maritalStatus', header: 'MARITAL STATUS', headerAlign: 'center', cellAlign: 'center', width: 20 },
    { columnDef: 'ownerType', header: 'OWNER TYPE', headerAlign: 'center', cellAlign: 'center', width: 20 },
    { columnDef: 'ownerShare', header: 'OWNER SHARE', headerAlign: 'center', cellAlign: 'center', width: 20 },
  ];

  actionOptions: ActionOption[] = [

  ];

  orderBlackRiskscapeData: String = ''
  propertyDataValid: boolean = false;
  riskscapePropertyInfoData: RiskscapePropertyInfoDto = {};
  riskscapePropertyInfoNewData: RiskscapePropertyInfoDto = {};
  riskscapeExistingLandUseAndFeatureData: RiskscapeExistingLandUseAndFeatureDto = {};
  riskscapeDeedsCurrentOwnerInfoData: RiskscapeDeedsCurrentOwnerInfoDto | undefined = {};
  riskscapeDeedsCurrentOwnerInfoTableData: RiskscapeDeedsCurrentOwnerInfoDto[] = [];
  riskscapePropertyDetails: RiskscapePropertyDetailsDto = {};
  UpdatedPropertyDetail: PropertyDetailDto = {};
  LatLongCoordinates: string = "";
  LatLongCoordinatesNew: string = "";
  file: Blob;
  fileUrl: string = "";
  hideButtons = false;
  localityMapFileId: string = "";
  PropertyBoundaryImageURL: string = "";
  imageId: string = "";
  loading: boolean = false;
  propertyDescriptionAddressCorrect: boolean = false;
  propertyBoundaryCorrect: boolean = false;
  sellerInformationCorrect: boolean = false;
  confidentImportRiskscapeData: boolean = false;
  dataRiskscapeDeedsCurrentOwnerInfo = new MatTableDataSource(this.riskscapeDeedsCurrentOwnerInfoTableData);

  isPropertySelected: boolean = false;
  selectedButton: number = 0;
  confirmPropertyDetail: number = 0;
  selectedUnitNumber: any = "00000";
  addressLatLonData: any = null;
  propertyType: string = "";
  loadingCadaster: boolean = false;
  cadastre: UploadFileDto | null = null;
  cadasterPicture: any = 1;
  cadasterPictureBase64: string = "";
  selectedBoundaryButton: number = 0;
  cityTown: string = "";
  unitNumber: string = "";
  suburbName: string = "";
  propertyKey: string = "";
  shortAddress: string = "";
  erfOrPortionNumber: string = "";
  confirmPropertyBoundary: number = 0;
  attemptCount: number = 0;
  maxAttempts: number = 5;

  selectedPropertyOnMap: any;
  hideLatLonPanel: boolean = false;
  latitude: number | null = null;
  longitude: number | null = null;

  individualInvoiceDetails: IndividualInvoiceDetailsVm = {
    name: '',
    surname: '',
  }

  organizationInvoiceDetails: OrganizationInvoiceDetailsDto = {
    organizationName: '',
    companyRegistrationNumber: '',
    vatNumber: '',
  }

  contactInvoiceDetails: ContactDetailDto = {
    isTheContactDetailsToAppearOnInvoice: undefined,
    name: '',
    surname: '',
    landLine: '',
    mobile: '',
    emailAddress: '',
    confirmEmailAddress: '',
  }

  physicalAddress: AddressDto = {
    unitNumber: '',
    complexName: '',
    streetNumber: '',
    streetName: '',
    suburb: '',
    city: '',
    postalCode: '',
    addressFull: '',
    propertyDescription: '',
  };

  propertyDetailForm?: PropertyDetailDto = {
    invoiceIssuedTo: undefined,
    isTheOrganizationRegisteredForVat: null,
    isTheContactDetailsToAppearOnInvoice: null,
    isTheAddressToAppearOnInvoice: null,
    propertyAddress: '',
    propertyBoundaryConcern: '',
    wishToSell: undefined,
    mainPropertyUse: undefined,
    approximateBuildingAge: undefined,
    reasonForNotInterested: undefined,
    hasCopiesOfApprovedBuildingPlans: undefined,
    jointProperties: undefined,
    hasAskingPrice: false,
    allBuildingsDoneWithApprovedBuildingPlans: undefined,
    sellMoreThanOneProperty: false,
    propertyDescription: '',
    confirmCorrectAddressDetails: false,
    mainPropertyUseOther: '',
    approximateBuildingAgeOther: 0,
    hasValueAlteringInfluences: false,
    valueAlteringInfluencesDescription: '',
    tenantedBuildingsAmount: 0,
    hasImprovementPotential: false,
    futurePotential: '',
    latitude: 0,
    longitude: 0,
    correctAddress: false,
    askingPrice: 0,
    physicalAddress: this.physicalAddress,
    contactInvoiceDetails: this.contactInvoiceDetails,
    organizationInvoiceDetails: this.organizationInvoiceDetails,
    individualInvoiceDetails: this.individualInvoiceDetails,
    riskscapeInfo: {
      neighbourhoodId: '',
      sectionalTitleUnitNumber: '',
      subplaceId: '',
      surveyorGeneralKey: ''
    },
    riskscapeAddressGeocode: {
      data: []
    },
    riskscapeAddress: {
      data: undefined
    },
    riskscapePositionLookup: {
      data: undefined
    },
    riskscapePropertyDetails: {
      data: undefined
    },

  };

  currentUser: UserDto;

  cdr: ChangeDetectorRef;
  errorMessage: string[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private listingStateService: ListingStateService,
    private planningReportService: PlanningReportService,
    private reportingService: ReportingService,
    private propertyListingService: PropertyListingService,
    private fileManagementService: FileManagementService,
    private userManagementService: UserManagementService,
    private notificationService: NotificationService,
    private sharedService: PropertyMatrixSharedService,
    private sellMyPropertyService: SellMyPropertyService,
    private _mapsService: MapsService,
    private _mapStateCheckService: MapStateCheckService,
    private dialog: MatDialog,
  ) {
    this.file = new Blob();

    this.dataTable = new DataTableComponent(this.cdr);
    this.sort = new MatSort();
    this.paginator = this.dataTable.paginator;
  }

  ngOnInit(): void {
    try {
      if (this.selectedListing) {
        this.setCorrectAddress();
        this.loadRequiredCadastre();
        this.getReportPlanning();
        this.getCurrentOwnerInfo();
      } else {
        this.notificationService.showErrorMessage("Error", "The property listing could not be found.");
        this.goToAdminListings();
      }
    } catch (err) {
      this.notificationService.showErrorMessage("Error", "Could not load confirm property and seller.");
    }
    this.getCurrentUser();
  }

  collapseOrExpandSection(section: { checked: boolean; }) {
    try {
      section.checked = !section.checked;
      this._mapStateCheckService.updateMapState(true);
    } catch (err) {
      this.notificationService.showErrorMessage("Error", "Could not find mapping state check service.");
    }
  }

  saveDetails(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        this.loading = true;
        if (this.propertyDataValid == false) {
          if (!this.physicalAddress) {
            this.notificationService.showErrorMessage("Error", "The address details has errors. please make sure all fields have values and try again.");
            return;
          }
          if (this.selectedListing.propertyDetail.orderRiskscapeData == true) {
            if (!this.propertyDetailForm?.riskscapePropertyDetails?.data) {
              this.notificationService.showErrorMessage("Error", "The map coordinates lat long is not found. please make sure all fields have values and try again.");
              this.loading = false;
              return;
            }
          }

          this.selectedListing.propertyDetail!.addressDetail = {
            "isDeleted": false,
            "id": this.physicalAddress.id,
            "unitNumber": this.physicalAddress.unitNumber,
            "complexName": this.physicalAddress.complexName,
            "streetNumber": this.physicalAddress.streetNumber,
            "streetName": this.physicalAddress.streetName,
            "suburb": this.physicalAddress.suburb,
            "city": this.physicalAddress.city,
            "postalCode": this.physicalAddress.postalCode,
            "propertyDescription": this.physicalAddress.propertyDescription,
            "currentLandUse": this.physicalAddress.currentLandUse,
            "propertyAge": this.physicalAddress.propertyAge,
          };

          this.selectedListing.propertyDetail!.physicalAddress = {
            "id": this.physicalAddress.id ?? undefined,
            "ownershipDetailsId": this.physicalAddress.ownershipDetailsId ?? undefined,
            "unitNumber": this.physicalAddress.unitNumber ?? undefined,
            "complexName": this.physicalAddress.complexName ?? undefined,
            "streetNumber": this.physicalAddress.streetNumber ?? undefined,
            "streetName": this.physicalAddress.streetNumber ?? undefined,
            "suburb": this.physicalAddress.suburb ?? undefined,
            "city": this.physicalAddress.city ?? undefined,
            "postalCode": this.physicalAddress.postalCode ?? undefined,
            "propertyDescription": this.physicalAddress.propertyDescription ?? undefined,
            "currentLandUse": this.physicalAddress.currentLandUse ?? undefined,
            "municipality": this.physicalAddress.municipality ?? undefined,
            "metro": this.physicalAddress.metro ?? undefined,
            "addressFull": this.physicalAddress.addressFull ?? undefined,
            "propertyAge": this.physicalAddress.propertyAge ?? undefined
          };

          if (this.propertyDetailForm.riskscapePropertyDetails.data && this.propertyDetailForm?.riskscapePropertyDetails?.data?.position) {
            const position = this.propertyDetailForm?.riskscapePropertyDetails?.data?.position;
            this.selectedListing.propertyDetail!.latitude = position.lat ?? 0;
            this.selectedListing.propertyDetail!.longitude = position.lon ?? 0;
          }
        } else {

          if (!this.riskscapePropertyInfoData) {
            this.notificationService.showErrorMessage("Error", "The address details has errors. Please make sure all fields have values and try again.");
            return;
          }
          if (!this.riskscapePropertyInfoNewData) {
            this.notificationService.showErrorMessage("Error", "The Property details has errors. Please make sure all fields have values and try again.");
            return;
          }

          this.selectedListing.propertyDetail!.addressDetail = {
            "isDeleted": false,
            "id": this.riskscapePropertyInfoData.id,
            "unitNumber": this.riskscapePropertyInfoData.sectionalTitleUnitNumber,
            "complexName": this.riskscapePropertyInfoData.complexName,
            "streetNumber": this.riskscapePropertyInfoData.streetNumber,
            "streetName": this.riskscapePropertyInfoData.streetName,
            "suburb": this.riskscapePropertyInfoData.suburbName,
            "city": this.riskscapePropertyInfoData.city,
            "postalCode": '',
            "currentLandUse": '',
            "propertyAge": 0,
          };
          this.selectedListing.propertyDetail!.physicalAddress = {
            "id": this.riskscapePropertyInfoNewData.id,
            "complexName": this.riskscapePropertyInfoNewData.complexName,
            "streetNumber": this.riskscapePropertyInfoNewData.streetNumber,
            "streetName": this.riskscapePropertyInfoNewData.streetNumber,
            "suburb": this.riskscapePropertyInfoNewData.suburbName,
            "city": this.riskscapePropertyInfoNewData.city,
            "municipality": this.riskscapePropertyInfoNewData.municipality,
            "ownershipDetailsId": 0,
          };
        }
        if (this.selectedListing.propertyDetail) {
          this.selectedListing.propertyDetail.propertyAddress = this.selectedListing.propertyDetail.propertyAddress;
          this.selectedListing.propertyDetail.propertyDescription = this.selectedListing.propertyDetail.propertyDescription;
          this.selectedListing.propertyDetail.confirmCorrectAddressDetails = this.propertyDescriptionAddressCorrect;
          this.selectedListing.propertyDetail.agreeWithPropertyBoundary = this.propertyBoundaryCorrect;
          this.selectedListing.propertyDetail.correctAddress = this.propertyDescriptionAddressCorrect;
          this.selectedListing.propertyDetail.sellerInformationCorrect = this.sellerInformationCorrect;
          this.selectedListing.propertyDetail.confidentImportRiskscapeData = this.confidentImportRiskscapeData
          this.selectedListing.propertyDetail.orderRiskscapeData = this.orderBlackRiskscapeData == "order" ? true : false;

          if (this.LatLongCoordinatesNew) {
            this.selectedListing.propertyDetail.latitude = this.latitude;
            this.selectedListing.propertyDetail.longitude = this.longitude;
          } else if (this.LatLongCoordinates) {
            this.selectedListing.propertyDetail.latitude = this.latitude;
            this.selectedListing.propertyDetail.longitude = this.longitude;
          }
          else {
            this.notificationService.showWarningMessage("Warning", "The map coordinates does not have value, make sure it has values to continue.");
            return;
          }
        } else {
          this.notificationService.showErrorMessage("Error", "The selected listing property is empty.");
          return;
        }

        this.propertyListingService.apiV1PropertyListingEditOrUpdatePropertyDetailPost({
          body: this.selectedListing.propertyDetail, propertyListingId: this.selectedListing.id
        }).subscribe({
          next: (retult: any) => {
            this.loading = false;
            this.loadingCadaster = false;
            if (retult) {
              resolve(true);
            } else {
              this.notificationService.showErrorMessage("Error", 'Error Updating Property Details.');
              resolve(false);
            }
          },
          error: (_error: any) => {
            this.loading = false;
            this.loadingCadaster = false;
            this.notificationService.showErrorMessage('Error', 'Error updating property details.');
            resolve(false);
          }
        });
      } catch (ex) {
        this.notificationService.showErrorMessage("Error", 'Error updating property details.');
        this.loading = false;
        this.loadingCadaster = false;
        resolve(false);
        reject("Error caught on service call save details.");
      }
    });
  }

  openLocationDialog(): void {
    const dialogRef = this.dialog.open(ProvideLatLonDialogComponent, {
      width: '300px',
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.latitude = result.latitude;
        this.longitude = result.longitude;
        this.LatLongCoordinatesNew = `${this.latitude} ${this.longitude}`;

        if (this.propertyDetailForm?.riskscapePropertyDetails?.data?.position) {
          this.propertyDetailForm.riskscapePropertyDetails.data.position.lat = this.latitude;
          this.propertyDetailForm.riskscapePropertyDetails.data.position.lon = this.longitude;
        } else {
          this.notificationService.showWarningMessage("Warning", "Position is not available in propertyDetailForm.");
          console.warn("Position is not available in propertyDetailForm.");
        }
      }
    });
  }

  async saveConfirmDetails(): Promise<void> {
    try {
      let validdationPassed = await this.checkIfCheckboxesAllChecked();

      if (validdationPassed == false) {
        let combinedMessage = "";
        combinedMessage = this.errorMessage.join('<br>');
        this.notificationService.showErrorMessageHTML("Error", combinedMessage);
      } else {
        this.loading = true;
        let savedData = await this.saveDetails();
        if (savedData == true) {
          this.listingStateService.setSelectedListing(this.selectedListing);
          let changedTaskLists = [] as TaskListDto[];
          this.selectedListing.taskList.forEach(task => {
            if (task.taskNumber.number === 2) {
              if (task.taskStatus.taskStatusNumber != 3) {
                task.user = this.currentUser;
                changedTaskLists.push(task);
              }
            }
            if (task.taskNumber.number === 3) {
              if (task.taskStatus.taskStatusNumber == 1) {
                task.user = this.currentUser;
                changedTaskLists.push(task);
              }
            }
          });

          if (changedTaskLists.length > 0) {
            this.propertyListingService
              .apiV1PropertyListingUpdatePropertyListingTaskPost({ body: changedTaskLists, currentTaskNumber: 2 })
              .subscribe(result => {

                if (result == null) {
                  this.notificationService.showErrorMessage('Error', 'Failed to update planners.');
                  this.loading = false;
                  return;
                }
                this.notificationService.showSuccessMessage("Saved", "Saved successfully and task completed.");
                this.loading = false;
                this.navigateToPlanningReport();
              });

          } else {
            this.notificationService.showSuccessMessage("Saved", "Saved successfully and task completed.");
            this.loading = false;
            this.navigateToPlanningReport();
          }

        } else {
          this.loading = false;
          this.notificationService.showErrorMessage("Error", "Could not save details")
        }

      }
    }
    catch (ex) {
      this.loading = false;
      this.notificationService.showErrorMessage('Error', 'Could not complete the Confirm property and seller details because of errors.');
    }
  }

  async saveData(): Promise<void> {
    try {
      let validdationPassed = await this.checkIfCheckboxesAllChecked();
      if (validdationPassed == false) {
        let combinedMessageSave = "";
        combinedMessageSave = this.errorMessage.join('<br>');
        this.notificationService.showErrorMessageHTML("Error", combinedMessageSave);
      } else {
        this.loading = true;
        let savedData = await this.saveDetails();
        if (savedData == true) {
          this.listingStateService.setSelectedListing(this.selectedListing);
          this.notificationService.showSuccessMessage("Saved", "Saved successfully and task completed")
        } else {
          this.notificationService.showErrorMessage("Error", "Could not save details")
        }
      }
      this.loading = false;
    }
    catch (ex) {
      this.loading = false;
      this.notificationService.showErrorMessage('Error', 'Could not complete the Confirm property and seller details because of errors.');
    }
  }

  async getCurrentOwnerInfo(): Promise<void> {
    try {
      this.riskscapeDeedsCurrentOwnerInfoTableData = [];

      let result = this.planningReportService.apiV1PlanningReportGetAddendumThreeDetailsGet({ propertyListingId: this.selectedListing.id }).subscribe({
        error(err) {
          this.notificationService.showErrorMessage('Error', 'Error getting the Addendum data');
        },
        next: (reportData: AddendumThreeDto) => {
          this.loading = false;
          if (reportData) {
            this.riskscapeDeedsCurrentOwnerInfoData = reportData?.riskscapeDeedsCurrentOwnerInfo;
            if (this.riskscapeDeedsCurrentOwnerInfoData) {
              this.riskscapeDeedsCurrentOwnerInfoTableData.push(this.riskscapeDeedsCurrentOwnerInfoData);
              this.dataRiskscapeDeedsCurrentOwnerInfo.data = this.riskscapeDeedsCurrentOwnerInfoTableData;
              this.dataRiskscapeDeedsCurrentOwnerInfo.sort = this.sort;
              this.dataRiskscapeDeedsCurrentOwnerInfo.paginator = this.paginator;
            } else {
              this.notificationService.showErrorMessage("Error", "No Addendum data found");
            }
          } else {
            this.notificationService.showErrorMessage("Error", "There are no 3rd party owner information found.");
          }
        },
      });
    } catch (err) {
      this.loading = false;
      this.notificationService.showErrorMessage("Error", "There are no 3rd party owner information found.");
    }
  }

  async getReportPlanning(): Promise<void> {
    try {
      let result = await this.planningReportService.apiV1PlanningReportGetPlanningReportDetailsGet({ propertyListingId: this.selectedListing.id })
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Could not get the planning report data."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((planningReport: PlanningReportDto | void) => {
          if (planningReport) {
            this.riskscapePropertyInfoData = planningReport?.riskscapePropertyInfo || {};
            this.riskscapePropertyInfoNewData = planningReport?.riskscapePropertyInfo || {};
            this.riskscapeExistingLandUseAndFeatureData = planningReport?.riskscapeExistingLandUseAndFeature || {};
            this.getPropertyBoundary(this.riskscapePropertyInfoData.surveyorGeneralKey ?? "");
            this.selectedUnitNumber = this.riskscapePropertyInfoData.sectionalTitleUnitNumber;
            this.getPropertyDetailsData(this.riskscapePropertyInfoData.surveyorGeneralKey ?? "", this.riskscapePropertyInfoData.sectionalTitleUnitNumber ?? "");
          }
        });
    } catch (err) {
      this.notificationService.showErrorMessage("Error", "Could not get the planning report data");
    }
  }

  addNewRow(): void {
    const newRow = {
      name: '',
      idNumber: '',
      maritalStatus: '',
      ownerType: '',
      ownerShare: ''
    };

    this.riskscapeDeedsCurrentOwnerInfoTableData.push(newRow);
  }

  setPropertyBoundaryImageURL(): void {
    this.PropertyBoundaryImageURL = this.selectedListing?.image ?? "";
  }

  getPropertyBoundary(propertyKey: string): void {
    try {
      this.PropertyBoundaryImageURL = "";
      this.loading = true;
      let result = this._mapsService.apiV1MapsGetDecodedRiskscapePropertyImageGet({ propertyKey: propertyKey })
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Could not get the property image."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((riskscapePropertyImage: any) => {
          if (riskscapePropertyImage) {
            this.imageId = riskscapePropertyImage.imageId ?? "";
            this.PropertyBoundaryImageURL = riskscapePropertyImage.imageUrl ?? "";
            this.hideButtons = true;
          }
        });
    } catch (err) {
      this.loading = false;
      this.notificationService.showErrorMessage("Error", "Could not get the Property Boundaries.");
    }
  }

  getPropertyDetailsData(propertyKey: string, unitNumber: string): void {
    try {
      this.loading = true;
      let result = this._mapsService.apiV1MapsGetPropertyDetailsGet({ propertyKey: propertyKey, unitNumber })
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Could not get the Property Details map service data."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((riskscapePropertyDetails: any) => {
          if (riskscapePropertyDetails) {
            this.riskscapePropertyDetails = riskscapePropertyDetails;
            this.latitude = riskscapePropertyDetails.position.lat ?? 0;
            this.longitude = riskscapePropertyDetails.position?.lon ?? 0;
            this.LatLongCoordinates = riskscapePropertyDetails.position.lat + " " + riskscapePropertyDetails.position.lon;
          }
        });
    } catch (err) {
      this.notificationService.showErrorMessage("Error", "Could not get the Property Details map service data.");
      this.loading = false;
    }
  }

  async setFile(event: { target: { files: any[]; }; }) {
    try {
      this.localityMapFileId = await this.reportingService.uploadFile(event.target.files[0]);
      this.file = event.target.files[0];

      var reader = new FileReader();

      reader.onload = (event: any) => {
        this.fileUrl = event.target.result;
        this.hideButtons = true;
      };

      reader.readAsDataURL(this.file);
    }
    catch (error) {
      this.loading = false;
      this.notificationService.showErrorMessage('Error', 'Could not upload file.');
    }
  }

  setCorrectAddress(): void {
    try {
      if (this.selectedListing.propertyDetail) {

        switch (this.selectedListing.propertyDetail.agreeWithPropertyBoundary) {
          case null: {
            this.confirmPropertyBoundary = 2;
            break;
          }
          case true: {
            this.confirmPropertyBoundary = 3;
            break;
          }
          case false: {
            this.confirmPropertyBoundary = 1;
            break;
          }
          default:
            {
              break;
            }
        }

        switch (this.selectedListing.propertyDetail.confirmCorrectAddressDetails) {
          case null: {
            this.confirmPropertyDetail = 2;
            break;
          }
          case true: {
            this.confirmPropertyDetail = 3;
            break;
          }
          case false: {
            this.confirmPropertyDetail = 1;
            break;
          }
          default:
            {
              break;
            }
        }

        this.propertyDataValid = this.selectedListing.propertyDetail.confirmCorrectAddressDetails ?? false;
        this.propertyDescriptionAddressCorrect = this.selectedListing.propertyDetail?.correctAddress;
        this.propertyBoundaryCorrect = this.selectedListing.propertyDetail?.agreeWithPropertyBoundary;
        this.sellerInformationCorrect = this.selectedListing.propertyDetail?.sellerInformationCorrect ?? false;
        this.confidentImportRiskscapeData = this.selectedListing.propertyDetail?.confidentImportRiskscapeData ?? false;
      } else {
        this.notificationService.showWarningMessage("Warning", "The selected listing is null.");
      }
    }
    catch (error) {
      this.loading = false;
      this.notificationService.showErrorMessage('Error', 'Error setting the listing item.');
    }
  }

  replace() {
    try {
      this.fileUrl = "";
      this.PropertyBoundaryImageURL = "";
      this.hideButtons = false;
    } catch (err) {
      this.notificationService.showErrorMessage("Error", "Can not replace image because of an error found.");
    }
  }

  deleteFile(): void {
    try {
      if (this.imageId) {
        this.notificationService.showConfirmMessage('Confirm Deletion', 'Are you sure you want to remove this listing?').then((confirmed) => {
          if (confirmed) {
            this.fileManagementService.apiV1FileManagementDeleteFileFileIdDelete({ fileId: this.imageId }).subscribe({
              next: () => {
                this.notificationService.showSuccessMessage('Success', 'Listing removed successfully.');
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              },
              error: (_error: any) => {
                this.notificationService.showErrorMessage('Error', 'Could not removed listing.');
              }
            });
          }
        });
      } else {
        this.notificationService.showErrorMessage("Error", "The file Id not found");
      }
    } catch (err) {
      this.notificationService.showErrorMessage("Error", "Could not save delete image.");
    }
  }

  handleSelectedPropertyChange(propertyIdentification: any): void {
    try {
      if (propertyIdentification !== null) {
        this.selectedPropertyOnMap = propertyIdentification;
        this.isPropertySelected = true;
        this.confirmPropertyDetail = 1;
      } else {
        this.isPropertySelected = false;
        this.confirmPropertyDetail = 1;
        this.notificationService.showWarningMessage(
          'Warning',
          'Address not found or 3rd party is unavailable. Please re-enter the address or try again later.');
      }
    } catch (err) {
      this.loading = false;
      this.notificationService.showErrorMessage("Error", 'Address not found or 3rd party is unavailable. Please re-enter the address or try again later.');
    }
  }

  doRiskscapeData(): void {
    try {
      if (this.attemptCount >= this.maxAttempts) {
        this.notificationService.showErrorMessage(
          'Limit Reached',
          'You have reached the maximum number of attempts allowed.'
        );
        return;
      }
      if ((this.selectedPropertyOnMap !== null) && (this.isPropertySelected == true)) {

        this.attemptCount = this.attemptCount + 1;
        this.isPropertySelected = true;
        this.confirmPropertyDetail = this.selectedButton;
        this.getAddressFromLatLon(this.selectedPropertyOnMap.position.lat, this.selectedPropertyOnMap.position.lon);
        this.selectedUnitNumber = this.selectedPropertyOnMap.unit_number;
        this.riskscapePropertyInfoNewData.sectionalTitleUnitNumber = this.selectedPropertyOnMap.unit_number;
      } else {
        this.isPropertySelected = false;
        this.confirmPropertyDetail = 1;
        this.notificationService.showWarningMessage(
          'Warning',
          'Address not found or 3rd party is unavailable. Please re-enter the address or try again later.');
      }
    } catch (err) {
      this.notificationService.showErrorMessage("Error", 'Address not found or 3rd party is unavailable. Please re-enter the address or try again later.');
    }
  }

  selectButton(buttonNumber: number) {
    this.selectedButton = buttonNumber;
    this.confirmPropertyDetail = buttonNumber;
  }

  selectBoundaryButton(buttonNumber: number) {
    this.selectedBoundaryButton = buttonNumber;
    this.confirmPropertyBoundary = buttonNumber;
  }

  handleScriptLoadStatus(statusMessage: string): void {
    if (statusMessage) {
      this.notificationService.showWarningMessage(
        'Oops! Something went wrong.',
        statusMessage
      );
    }
  }

  getAddressFromLatLon(lat: string, lon: string) {
    try {
      this.loading = true;
      this._mapsService.apiV1MapsGetPropertyDetailsFromLatLonGet({
        lat: lat,
        lon: lon
      })
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Could not find address."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((result: RiskscapePositionLookupDto | void) => {
          if (result) {
            this.propertyDetailForm!.riskscapeAddressGeocode!.data = null;
            this.propertyDetailForm!.riskscapePositionLookup = result;
            this.addressLatLonData = this.propertyDetailForm?.riskscapePositionLookup;
            this.propertyType = this.addressLatLonData.type;
            if (this.addressLatLonData.attributes.property_key) {
              this.getAddressDetails(this.addressLatLonData.attributes.address_id);
              this.getAddressImage(this.addressLatLonData.attributes.property_key);
              this.getPropertyDetails(this.addressLatLonData.attributes.property_key, this.selectedUnitNumber);
              this.propertyDetailForm!.riskscapeInfo!.surveyorGeneralKey = this.addressLatLonData.attributes.property_key;
              this.propertyDetailForm!.riskscapeInfo!.sectionalTitleUnitNumber = this.selectedUnitNumber;
              this.riskscapePropertyInfoNewData.surveyorGeneralKey = this.addressLatLonData.attributes.property_key;
            } else {
              this.notificationService.showErrorMessage("Error", "The 3rd party position lookup property key for does not have value: " + this.addressLatLonData.attributes.property_key);
            }
          } else {
            this.notificationService.showErrorMessage("Error", "Could not get the 3rd party Position Lookup data.")
          }
        });
    } catch (err) {
      this.loading = false;
      this.notificationService.showErrorMessage("Error", 'Could not find address.');
    }
  }

  getAddressDetails(addressId: string) {
    try {
      this.loading = true;
      this._mapsService.apiV1MapsGetAddressDetailsGet$Response({
        addressId: addressId
      })
        .subscribe({
          next: (result: any) => {
            this.loading = false;
            if (result && result.body) {
              const riskscapeAddressDto: RiskscapeAddressDto = result.body;
              this.propertyDetailForm!.riskscapeAddress = riskscapeAddressDto;
              if (this.propertyDetailForm!.riskscapePropertyDetails?.data?.position) {
                const position = this.propertyDetailForm?.riskscapeAddress?.data?.position;
                this.propertyDetailForm!.latitude = position?.lat ?? 0;
                this.propertyDetailForm!.longitude = position?.lat ?? 0;
              } else {
                this.notificationService.showErrorMessage("Error", "Could not get map coordinates from 3rd party.");
              }

              this.propertyDetailForm!.physicalAddress = this.physicalAddress = {
                unitNumber: this.selectedUnitNumber,
                complexName: this.propertyDetailForm?.riskscapeAddress?.data?.complex ?? '',
                streetNumber: this.propertyDetailForm?.riskscapeAddress?.data?.street_number ?? '0',
                streetName: this.propertyDetailForm?.riskscapeAddress?.data?.street ?? '0',
                suburb: this.propertyDetailForm?.riskscapeAddress?.data?.subplace ?? '',
                city: this.propertyDetailForm?.riskscapeAddress?.data?.city_town ?? '',
                postalCode: this.propertyDetailForm?.riskscapeAddress?.data?.postal_code ?? '0',
                addressFull: this.propertyDetailForm?.riskscapeAddress?.data?.full_address ?? '',
                currentLandUse: '',
                metro: this.propertyDetailForm?.riskscapeAddress?.data?.district,
                municipality: this.propertyDetailForm?.riskscapeAddress?.data?.municipality,
                ownershipDetailsId: 0,
                propertyAge: 0,
                propertyDescription: '',
                id: addressId,
              }
              this.unitNumber = this.physicalAddress.unitNumber == undefined ? 'N/A' : this.physicalAddress.unitNumber;
              this.erfOrPortionNumber = result.body.erfNumber == undefined ? 'N/A' : result.data.erfNumber;
              this.shortAddress = this.physicalAddress.streetNumber + ' ' + this.physicalAddress.streetName;
              this.suburbName = this.physicalAddress.suburb == undefined ? 'N/A' : this.physicalAddress.suburb;
              this.cityTown = this.physicalAddress.city == undefined ? 'N/A' : this.physicalAddress.city;

              this.riskscapePropertyInfoNewData.city = this.physicalAddress.city;
              this.riskscapePropertyInfoNewData.complexName = this.physicalAddress.complexName;
              this.riskscapePropertyInfoNewData.portionNumber = this.erfOrPortionNumber;
              this.riskscapePropertyInfoNewData.province = this.propertyDetailForm?.riskscapeAddress?.data?.province;
              this.riskscapePropertyInfoNewData.streetName = this.physicalAddress.streetName;
              this.riskscapePropertyInfoNewData.streetNumber = this.physicalAddress.streetNumber;
              this.riskscapePropertyInfoNewData.subPlaceName = this.physicalAddress.suburb;
              this.riskscapePropertyInfoNewData.suburbName = this.propertyDetailForm?.riskscapeAddress?.data?.subplace;
            } else {
              this.notificationService.showErrorMessage('Error', 'Could not load address details.');
            }

            this.loading = false;
            this.loadingCadaster = false;
          },
          error: (_error: any) => {
            this.notificationService.showErrorMessage('Error', 'Could not load address details.');
            this.loading = false;
          }
        });
    } catch (err) {
      this.loading = false;
      this.notificationService.showErrorMessage("Error", 'Could not load address details.');
    }
  }

  async getAddressImage(propertyKey: string) {
    try {
      this.loading = true;
      this.loadingCadaster = true;
      let result = await this.sharedService.getAddressImage(propertyKey);
      if (result?.ok && result.body) {
        this.loading = false;
        this.loadingCadaster = false;
        const resultJson = JSON.parse(result.body);
        this.cadasterPictureBase64 = resultJson.encoded;
        const base64Response = await fetch(`data: image / jpeg; base64, ${this.cadasterPictureBase64} `);
        const blob = await base64Response.blob();
        let objectURL = URL.createObjectURL(blob);
        this.cadasterPicture = await this.sharedService.getImageFromDataUri(objectURL);
        this.cadastre!.file = blob;
      } else {
        this.notificationService.showErrorMessage('Error', 'Could not find address image.');
      }
      this.loading = false;
      this.loadingCadaster = false;
    } catch (err) {
      this.notificationService.showErrorMessage("Error", String(err));
      this.loading = false;
    }
  }

  getPropertyDetails(propertyKey: string, unitNumber: string): void {
    try {
      this.loading = true;
      this._mapsService.apiV1MapsGetPropertyDetailsGet$Response({
        propertyKey: propertyKey,
        unitNumber: unitNumber
      })
        .pipe(
          catchError((err) =>
            of(this.notificationService.showErrorMessage("Error", "Could not load property details."))
          ),
          finalize(() => {
            this.loading = false;
          })
        )
        .subscribe((result: any | void) => {
          if (result && result.body) {
            this.propertyDetailForm!.riskscapePropertyDetails!.data = result.body;
            if (this.propertyDetailForm?.riskscapePropertyDetails?.data) {
              this.riskscapePropertyInfoNewData.deedsErfExtent = this.propertyDetailForm?.riskscapePropertyDetails?.data.extent ?? 0;
              this.riskscapePropertyInfoNewData.erfNumber = this.propertyDetailForm?.riskscapePropertyDetails?.data.erf_number ?? "";
              this.riskscapePropertyInfoNewData.fullAddress = this.propertyDetailForm?.riskscapePropertyDetails?.data.full_address ?? "";
              this.riskscapePropertyInfoNewData.id = this.propertyDetailForm?.riskscapePropertyDetails?.data.address_id ?? "";
              this.riskscapePropertyInfoNewData.municipality = this.propertyDetailForm?.riskscapePropertyDetails?.data.municipality ?? "";
              this.riskscapePropertyInfoNewData.suburbName = this.propertyDetailForm?.riskscapePropertyDetails?.data.subplace ?? "";
              this.riskscapePropertyInfoNewData.propertyType = this.propertyDetailForm?.riskscapePropertyDetails?.data.property_type ?? "";
              if (this.propertyDetailForm?.riskscapePropertyDetails?.data?.position) {
                const position = this.propertyDetailForm.riskscapePropertyDetails.data.position;
                this.propertyDetailForm.latitude = position.lat ?? 0;
                this.propertyDetailForm.longitude = position.lon ?? 0;
                this.latitude = position.lat ?? 0;
                this.longitude = position.lon ?? 0;
                this.LatLongCoordinatesNew = `${position.lat?.toString() ?? ""} ${position.lon?.toString() ?? ""} `;
              } else {
                this.notificationService.showErrorMessage("Error", "Could not get map coordinates from 3rd party.");
              }
            }
          } else {
            this.notificationService.showErrorMessage("Error", "Could not get map coordinates from 3rd party.");
          }
        });
    } catch (err) {
      this.loading = false;
      this.notificationService.showErrorMessage("Error", 'Could not load property details.');
    }
  }

  loadRequiredCadastre() {
    try {
      this.loading = true;
      this.sellMyPropertyService.apiV1SellMyPropertyLoadRequiredCadastreGet().subscribe({
        next: (res: UploadFileDto) => {
          this.loading = false;
          this.cadastre = res;
        },
        error: (_error: any) => {
          this.loading = false;
          this.notificationService.showErrorMessage('Error', 'Could not load required cadastre.');
        }
      });
    } catch (err) {
      this.loading = false;
      this.notificationService.showErrorMessage("Error", 'Could not load required cadastre.');
    }
  }

  orderRiskscapeData(): void {
    try {
      this.orderBlackRiskscapeData = "order";
      this.doRiskscapeData();
    } catch (err) {
      this.loading = false;
      this.notificationService.showErrorMessage("Error", 'Error found on ordering 3rd party data.');
    }
  }

  blackRiskscapeData(): void {
    this.orderBlackRiskscapeData = "black";
  }

  goToAdminListings() {
    this.router.navigate(['admin/listings']);
  }

  getCurrentUser(): void {
    this.userManagementService.apiV1UserManagementGetCurrentUserGet().subscribe(result => {
      if (result != null) {
        this.currentUser = result;
      }
      else {
        this.notificationService.showWarningMessage('No Current User', 'No current user found.');
      }
    });
  }

  navigateToPlanningReport(): void {
    this.propertyListingService.apiV1PropertyListingGetPropertyListingByIdGet({ listingId: this.selectedListing.id }).subscribe(result => {
      this.selectedListing = result;
      this.listingStateService.setSelectedListing(this.selectedListing);
      this.router.navigate(['admin/listings/listing-overview'], {
        queryParams: {
          listingType: this.listingType
        }
      });
    });
  }

  private async checkIfCheckboxesAllChecked(): Promise<boolean> {
    this.errorMessage = [];
    this.errorMessage.push("Please check the following in section 6 or 10:<br>");
    if (this.propertyDescriptionAddressCorrect != true) {
      this.errorMessage.push("The property description and address is correct.");
    }
    if (this.propertyBoundaryCorrect != true) {
      this.errorMessage.push("The property boundary is correct.");
    }
    if (this.sellerInformationCorrect != true) {
      this.errorMessage.push("The seller information is correct.");
    }
    if (this.confidentImportRiskscapeData != true) {
      this.errorMessage.push("I am  confident import 3rd party data.");
    }

    if (this.errorMessage.length > 1) {
      return false;
    } else {
      return true;
    }
  }
}
